'use client';

import { createContext, useContext } from 'react';

type TooltipContextStateValue = {
    open: boolean;
};

type TooltipContextActionsValue = {
    open: () => void;
    close: () => void;
};

export const TooltipContextState =
    createContext<TooltipContextStateValue | null>(null);

export const TooltipContextActions =
    createContext<TooltipContextActionsValue | null>(null);

export function useTooltipState() {
    const context = useContext(TooltipContextState);

    if (!context) {
        throw new Error(
            'useTooltipContext must be used within a TooltipContext.Provider'
        );
    }

    return context;
}

export function useTooltipActions() {
    const context = useContext(TooltipContextActions);

    if (!context) {
        throw new Error(
            'useTooltipActions must be used within a TooltipContext.Provider'
        );
    }

    return context;
}
